const API_URL = '/api/'
const IMG_URL = '/api/'

// Endpoints que NO deben disparar logout al recibir 401
const RUTAS_PUBLICAS = ['ajustes.php', 'auth.php']

const HttpService = {

  getToken() {
    return localStorage.getItem('jwt_token')
  },

  async _post(ruta, datos) {
    const token = this.getToken()
    let res
    try {
      res = await fetch(API_URL + ruta, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': 'Bearer ' + token } : {}),
        },
        body: JSON.stringify(datos),
      })
    } catch (e) {
      // Error de red — no hacer nada, el catch del llamador lo maneja
      console.warn('Error de red al llamar ' + ruta, e)
      return null
    }

    if (res.status === 401) {
      const esPublica = RUTAS_PUBLICAS.some(function(r) { return ruta.includes(r) })
      if (!esPublica && token) {
        // Sesión expirada: limpiar y recargar UNA SOLA VEZ
        localStorage.clear()
        // Usar replace para evitar que el historial acumule recargas
        window.location.replace(window.location.origin + window.location.pathname)
        return null
      }
      return null
    }

    try {
      return res.json()
    } catch (e) {
      console.warn('Respuesta no-JSON de ' + ruta)
      return null
    }
  },

  registrar(datos, ruta) {
    return this._post(ruta, datos)
  },

  obtenerConDatos(datos, ruta) {
    return this._post(ruta, datos)
  },

  obtener(ruta) {
    const token = this.getToken()
    return fetch(API_URL + ruta, {
      headers: token ? { 'Authorization': 'Bearer ' + token } : {},
    }).then(function(res) { return res.json() }).catch(function() { return null })
  },

  eliminar(ruta, datos) {
    return this._post(ruta, datos)
  },

  login(datos) {
    return fetch(API_URL + 'auth.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ metodo: 'login', datos: datos }),
    }).then(function(res) { return res.json() }).catch(function() { return null })
  },

  buscar(termino) {
    return this._post('busqueda.php', { termino: termino })
  },

  obtenerAlertas() {
    return this._post('alertas.php', { metodo: 'obtener' })
  },

  obtenerReporteAnual(anio) {
    return this._post('reportes.php', { metodo: 'anual', anio: anio })
  },

  exportarPagos(filtros) {
    return this._post('reportes.php', { metodo: 'exportar_pagos', filtros: filtros })
  },

  obtenerRecibo(idPago) {
    return this._post('reportes.php', { metodo: 'recibo', idPago: idPago })
  },

  getImgUrl(imagen) {
    if (!imagen) return ''
    if (imagen.indexOf('data:') === 0) return imagen
    return IMG_URL + imagen
  },
}

export default HttpService


// WEBPACK FOOTER //
// ./src/Servicios/HttpService.js